import React from 'react';
import { Box, Button, Container, Paper, Stack, Typography } from '@mui/material';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import VideoCameraBackOutlinedIcon from '@mui/icons-material/VideoCameraBackOutlined';
import { useNavigate } from 'react-router-dom';

const LivaxuLandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#f5f7fb', px: 2 }}>
      <Container maxWidth="sm">
        <Paper elevation={0} sx={{ p: { xs: 4, sm: 6 }, borderRadius: 4, border: '1px solid', borderColor: 'divider', textAlign: 'center' }}>
          <Typography variant="overline" color="primary" sx={{ fontWeight: 700, letterSpacing: 2 }}>LIVAXU</Typography>
          <Typography variant="h3" component="h1" sx={{ mt: 1, mb: 1.5, fontWeight: 750 }}>Livaxu Sales Panel</Typography>
          <Typography color="text.secondary" sx={{ mb: 4 }}>Devam etmek istediğiniz uygulamayı seçin.</Typography>
          <Stack spacing={2}>
            <Button size="large" variant="contained" startIcon={<AdminPanelSettingsOutlinedIcon />} onClick={() => navigate('/admin-sales-login')} sx={{ py: 1.5 }}>
              Admin-Sales Login
            </Button>
            <Button size="large" variant="outlined" startIcon={<VideoCameraBackOutlinedIcon />} onClick={() => navigate('/video-creator-login')} sx={{ py: 1.5 }}>
              Video-Creator Login
            </Button>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default LivaxuLandingPage;
